import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { isSSR } from "./../../wix-rich-content-common";
import { getScaleImageSrc } from "./../../wix-rich-content-common/lib/imageUtils";
import styles from "../statics/styles/widget-scss";
import CardContent from "./CardContent";
const getImageTargetHeight = (width, height, targetWidth) => {
  const proportion = height / width;
  const targetHeight = proportion * targetWidth;
  return targetHeight;
};
const Card = (props) => {
  const { tabIndex } = useContext(RicosContext);
  const { url, content, direction, imageWidth, imageHeight, t, disabled } = props;
  const [imageSrc, setImageSrc] = useState();
  const getImageSrc = (targetWidth) => {
    const targetHeight = getImageTargetHeight(imageWidth, imageHeight, targetWidth);
    return getScaleImageSrc(props.imageSrc, targetWidth, targetHeight);
  };
  const setRef = (ref) => {
    if (ref) {
      const targetWidth = ref.getBoundingClientRect()?.width;
      if (imageWidth && imageHeight) {
        const imageSrc2 = getImageSrc(targetWidth);
        setImageSrc(imageSrc2);
      } else {
        setImageSrc(props.imageSrc);
      }
    }
  };
  const imageUrl = isSSR() ? imageWidth && imageHeight ? getImageSrc(185) : props.imageSrc : imageSrc;
  const imageStyle = imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    /* @__PURE__ */ React.createElement(
      "a",
      {
        className: styles.link,
        href: disabled ? null : url,
        target: "_blank",
        ref: setRef,
        tabIndex
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          style: { direction },
          className: classNames(styles[direction], styles.container, styles.cardLayout)
        },
        props.imageSrc && /* @__PURE__ */ React.createElement("div", { style: imageStyle, className: styles.image }),
        /* @__PURE__ */ React.createElement(CardContent, { ...content, disabled, t })
      )
    )
  );
};
Card.propTypes = {
  imageSrc: PropTypes.string,
  content: PropTypes.object,
  direction: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
  disabled: PropTypes.boolean,
  t: PropTypes.func.isRequired
};
var Card_default = Card;
export {
  Card_default as default
};
//# sourceMappingURL=Card.js.map
